/**
 * @voltxampere/web — `<vxa-templates>` placeholder (Sprint 11).
 *
 * Sprint 18 will populate this with starter circuits (RC
 * filter, BJT amp, opamp inverter, …). For Sprint 11 it is
 * a heading + a Zenit-italic placeholder copy so the sidebar
 * scroll has visual closure and signals "more coming".
 *
 * Copyright © 2026 360 Studio
 * Proprietary — All rights reserved.
 */

import { LitElement, html, css } from "lit";
import { customElement } from "lit/decorators.js";

import { currentLocale } from "../store/locale.js";
import { t } from "../i18n/index.js";
import { SignalController } from "../lit-utils/signal-controller.js";

@customElement("vxa-templates")
export class VxaTemplates extends LitElement {
  private readonly _locale = new SignalController(this, currentLocale);

  static override styles = css`
    :host {
      display: block;
      margin-top: var(--s-7);
      padding-top: var(--s-5);
      border-top: 1px solid var(--ivory-wisp);
    }

    .heading {
      font-family: var(--font-mono);
      font-size: var(--fs-mono-tiny);
      letter-spacing: 0.28em;
      color: var(--brass);
      text-transform: uppercase;
      margin-bottom: var(--s-3);
    }

    .placeholder {
      font-family: var(--font-body);
      font-style: italic;
      font-size: var(--fs-small);
      color: var(--ivory-faint);
      line-height: 1.5;
    }
  `;

  override render() {
    return html`
      <div class="heading">${t("sidebar.templates.heading")}</div>
      <p class="placeholder">${t("sidebar.templates.placeholder")}</p>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "vxa-templates": VxaTemplates;
  }
}
